module.exports = __webpack_public_path__ + "static/media/no-data.82ab57f7.png";